import makeSlice from '@web/slices/account/sliceMaker'

const slice = makeSlice({})

export default slice.reducer
export const actions = slice.actions
